
import { configureStore } from '@reduxjs/toolkit';

import authSlice from './slices/AuthSlice';
import snackbarSlice from './slices/SnackbarSlice';
import whatsAppNotificationSlice from './slices/WhatsAppNotificationSlice';

const store = configureStore({
    reducer: {
        auth:                   authSlice,
        snackbar:               snackbarSlice,
        whatsAppNotification:   whatsAppNotificationSlice,
    },
});

export type RootState = ReturnType<typeof store.getState>

export default store